import { createContext, Dispatch } from "react";

type initialStateType = {
  _id: string;
  _idCTP: Number;
  _bussinesName: string;
  openModalKardex: boolean;
  openConfirmFinishCourse: boolean;
};

type ModalPartial = {
  state: initialStateType;
  dispatch: Dispatch<any>;
};

export const initialState = {
  _id: "",
  _idCTP: 0,
  _bussinesName: "",
  openModalKardex: false,
  openConfirmFinishCourse: false,
};

export enum Types {
  OPEN_KARDEX = "OPEN_KARDEX",
  CLOSE_KARDEX = "CLOSE_KARDEX",
  CLOSE_CONFIRM_FINISH_COURSE = "CLOSE_CONFIRM_FINISH_COURSE",
  OPEN_CONFIRM_FINISH_COURSE = "OPEN_CONFIRM_FINISH_COURSE",
}

const ModalInitialState = {
  state: initialState,
  dispatch: () => null,
};

const TrainingContext = createContext<ModalPartial>(ModalInitialState);

export default TrainingContext;
